<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("SERVICECENTERS.ADD_SERVICECENTER") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <service-center-form
              :loading="loading"
              :serviceCenterData="serviceCenter"
              :formErrors="formErrors"
              @serviceCenterSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultServiceCenter from "./defaultServiceCenter";
import ServiceCenterForm from "./partials/ServiceCenterForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ServiceCenterForm,
  },

  mixins: [alertLeave],

  data() {
    const serviceCenter = cloneDeep(defaultServiceCenter);
    return {
      serviceCenter: serviceCenter,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List ServiceCenters" });
    },

    viewServiceCenter(serviceCenter) {
      this.alertLeave = false;
      this.$router.push({
        name: "View ServiceCenter",
        params: { id: serviceCenter.id },
      });
    },

    async handleSubmit(serviceCenter) {
      this.loading = true;
      const serviceCenterData = cloneDeep(serviceCenter);

      try {
        await this.$store.dispatch("serviceCenters/add", serviceCenterData);
        this.$notify({
          type: "success",
          message: this.$t("SERVICECENTERS.SERVICECENTER_ADDED"),
        });
        const serviceCenter = await this.$store.getters[
          "serviceCenters/serviceCenter"
        ];
        this.viewServiceCenter(serviceCenter);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const serviceCenter = await this.$store.getters[
          "serviceCenters/serviceCenter"
        ];
        if (serviceCenter.id) {
          await this.$store.dispatch(
            "serviceCenters/destroy",
            serviceCenter.id
          );
        }
        this.loading = false;
      }
    },
  },
};
</script>
